module.exports = __webpack_public_path__ + "img/11.ddc226e7.png";